import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';

/** A short confirmation at the bottom of the screen (Contact saved). */
const ToastContext = createContext<((message: string) => void) | null>(null);

const SHOW_MS = 4_000;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<{ text: string; at: number } | null>(null);
  const show = useCallback((text: string) => setMessage({ text, at: Date.now() }), []);

  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => setMessage(null), SHOW_MS);
    return () => clearTimeout(timer);
  }, [message]);

  return (
    <ToastContext.Provider value={show}>
      {children}
      <div className="toast-region" aria-live="polite">
        {message && (
          <div className="toast" key={message.at}>
            {message.text}
          </div>
        )}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast(): (message: string) => void {
  const show = useContext(ToastContext);
  if (!show) throw new Error('useToast outside ToastProvider');
  return show;
}
